import React, { Component } from 'react';

import CreatableSelect from 'react-select/creatable';
import NoSsr from '@material-ui/core/NoSsr';
import { withStyles } from '@material-ui/core/styles';

import { components, styles } from './ReactSelectWithMaterialUi';
import _ from '../../../utils/ObjectUtils';
import { PropTypes } from 'prop-types';
import TextField from '../textField/TextField';

class CreatableMultiSelectTextInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            inputValue: ''
        }
    };

    handleInputChange = inputValue => {
        this.setState({
            inputValue
        });
    }

    handleKeyDown = event => {
        const {
            inputValue
        } = this.state;

        const {
            handleFieldChange,
            value = []
        } = this.props;

        if (!inputValue) return;

        const valueAux = inputValue;

        switch (event.key) {
            case 'Enter':
            case 'Tab':
                this.setState({
                    inputValue: ''
                }, () => {
                    if (!value.includes(inputValue)) {
                        handleFieldChange([...value, valueAux]);
                    }
                });
                event.preventDefault();
                break;
            default:
                break;
        }
    };

    clearChip = (clearedFields, reactSelectEvent) => {
        //React-Select sends events as the second argument on field change
        //event.action === 'remove-value' - clear single chip was clicked (has 'removedValue')
        //event.action === 'clear' - clear all was clicked

        const {
            value,
            handleFieldChange
        } = this.props;

        switch (reactSelectEvent.action) {
            case 'remove-value':
                handleFieldChange(value.filter(v => v !== reactSelectEvent.removedValue.value))
                break;
            case 'clear':
                handleFieldChange([]);
                break
            default:
                break;
        }
    }

    render() {
        const { inputValue } = this.state;
        const {
            classes,
            theme,
            label,
            disabled,
            error,
            placeholder,
            value = [],
            width = 4
        } = this.props;

        const selectStyles = {
            input: base => ({
                ...base,
                color: theme.palette.text.primary,
                '& input': {
                    font: 'inherit',
                },
            }),
        };

        if(disabled) {
            return <TextField
                value={value.join(', ')}
                label={label}
                themeName="form"
                disabled={true}
            />
        }

        return (
            <div className={"col-lg-" + width + ( width < 6 ? " col-md-6 " : " col-md-12 ") + classes.root}>
                <NoSsr>
                    <CreatableSelect
                        classes={classes}
                        components={creatableComponents}
                        styles={selectStyles}
                        inputValue={inputValue}
                        isClearable
                        isMulti
                        menuIsOpen={false}
                        onChange={this.clearChip}
                        onInputChange={this.handleInputChange}
                        onKeyDown={this.handleKeyDown}
                        placeholder={placeholder}
                        value={value.map(v => ({
                            label: v,
                            value: v,
                            isFixed: disabled
                        }))}
                        textFieldProps={{
                            label,
                            InputLabelProps: {
                                shrink: true,
                            },
                            disabled: disabled,
                            error: !_.isNilOrEmpty(error),
                            helperText: error
                        }}
                    />
                </NoSsr>
            </div>
        );
    }
}

const creatableComponents = {
    ...components,
    DropdownIndicator: null
};

CreatableMultiSelectTextInput.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(CreatableMultiSelectTextInput);
